import Globalize from "globalize";
import strings from "strings/en-US.json";
import calendar from "cldr-data/main/en/ca-gregorian.json";
import numbers from "cldr-data/main/en/numbers.json";

Globalize.load(calendar);
Globalize.load(numbers);
export default strings;
